// 所有api名称集合

const API = {
  auth: {
    // 企微侧边栏获取页面配置签名
    getSignature: "/crop/sideBar/openApi/getSignature",
    // 登录
    login: "/crop/sideBar/openApi/login",
    // 企微客户和CRM客户绑定
    bindWechatToCrmCustomer: "/crop/sideBar/openApi/bindWechatToSchoolCustomer",
    // 企微客户和CRM客户解除绑定
    unbindWechatToCrmCustomer: "/crop/sideBar/openApi/unbindWechatToSchoolCustomer",
    // 企微侧边栏校验企微客户是否绑定CRM客户
    checkIfBindCustomer: "/crop/sideBar/openApi/checkIfBindCustomer",
  },
  detail: {
    // 企微侧边栏学员详情展示
    displayCustomerDetails: "/crop/sideBar/openApi/displayCustomerDetails",
    // 查询网校客户的订单
    queryOnlineSchoolCustomerOrder:
      "/crop/sideBar/openApi/queryOrderByCustomerId",
    // 编辑企微侧边栏学员详情
    editCustomerWeComBarDetails: "/crop/sideBar/openApi/editCustomerWeComBarDetails",
    // 根据订单ID查询缴费中、已支付支付明细信息 (排除已作废的支付凭证信息)
    selectPayWayDetailsByOrderId:
      "/crop/sideBar/openApi/selectPayWayDetailsByOrderId",
    //通过渠道选项获取广告位
    queryAdvertisingSpaceByChannel:
      "/customer/sdCrmCustomer/queryAdvertisingSpaceByChannel",
    // 复制记录提交
    saveCopyLog: "/crop/sideBar/openApi/addCrmCopyLog",
    // 侧边栏查询可赠送课程的下拉站点
    querySideBarClassTypeWebsiteList: '/crop/sideBar/openApi/querySideBarClassTypeWebsiteList',
    // 侧边栏查询可赠送的课程列表
    querySideBarClassTypePageList: '/crop/sideBar/openApi/querySideBarClassTypePageList',
    // 侧边栏赠送课程
    giftSideBarCourse: '/crop/sideBar/openApi/giftSideBarCourse',
    // 查询赠送课程用户是否有权限
    queryGiftCourseUserAuthority: '/crop/sideBar/openApi/queryGiftCourseUserAuthority'
  },
  // 系统相关
  manage: {
    // 加载所有省市区数据
    getRegionTreeList: "/crop/sideBar/openApi/querySchoolRegionTreeList",
    // 根据字典code查询字典
    queryDictItems: "/sys/dict/getDictItems/",
  },
  active: {
    //企微侧边栏活跃轨迹
    queryListOfWeChat:
      "/customer/sdCrmCustomerActiveTrajectory/queryListOfWeChat",
    // 活跃轨迹-复制字段
    queryValueByIdAndCode:
      "/customer/sdCrmCustomerActiveTrajectory/queryValueByIdAndCode",
    //营销推送 - 直播间列表
    allLiveList: "/mediaPlatform/dd/allLiveList",
    // 营销轨迹 - 留言记录
    queryMessageRecord: "/sideBar/openApi/queryCustomerLeaveMessageRecordList",
  },
};

export default API;
